import { PRO_ANNUAL_MONTHLY_EFFECTIVE } from "@garageregister/shared";
import { ArrowRight } from "lucide-react";

export function CTABanner() {
  return (
    <section className="bg-[#0C1222] py-20 sm:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl border border-[#4DB8C7]/20 bg-gradient-to-br from-[#4DB8C7]/10 via-[#151D2E] to-[#151D2E] p-10 sm:p-16 text-center">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 h-40 w-80 rounded-full bg-[#4DB8C7]/10 blur-3xl" />

          <div className="relative">
            <h2 className="font-heading text-3xl font-bold text-[#E8EDF2] sm:text-4xl">
              Ready to organize your garage?
            </h2>
            <p className="mx-auto mt-4 max-w-lg text-lg text-[#7A8FA3]">
              Free forever. No credit card required. Upgrade to Pro whenever
              you want — first month free on annual.
            </p>
            <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
              <a
                href="/get"
                className="group inline-flex items-center gap-2 rounded-xl bg-[#4DB8C7] px-8 py-3.5 text-base font-semibold text-[#0C1222] shadow-[0_0_20px_rgba(77,184,199,0.25)] transition-all hover:bg-[#3DA8B7] hover:shadow-[0_0_30px_rgba(77,184,199,0.35)]"
              >
                Download free
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
            </div>
            <p className="mt-4 text-xs text-[#4A5C6F]">
              Free forever for basic use &bull; Pro starts at ${PRO_ANNUAL_MONTHLY_EFFECTIVE}/mo
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
